import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import LoadingButton from '@mui/lab/LoadingButton';

const ProfileEditButtons = ({
  disabledEdit,
  loading,
  disableSaveButton,
  onEdit,
  onCancel,
  showInline,
}) => {
  const cancelButton = (
    <Button
      variant="secondary"
      color="primary"
      size="small"
      sx={{
        maxWidth: { xs: 'inherit', sm: 'fit-content' },
        py: 0.5,
      }}
      onClick={onCancel}
      id="info-cancel-button"
    >
      Cancelar
    </Button>
  );

  const mainButton = (
    <LoadingButton
      variant="contained"
      color="primary"
      size="small"
      loading={loading}
      disabled={!disabledEdit && disableSaveButton}
      onClick={onEdit}
      sx={{
        maxWidth: { xs: 'inherit', sm: 'fit-content' },
      }}
      id={disabledEdit ? 'info-edit-button' : 'info-save-button'}
    >
      {disabledEdit ? 'Editar' : 'Guardar cambios'}
    </LoadingButton>
  );

  if (showInline) {
    return mainButton;
  }

  return (
    <Stack
      direction={{ xs: 'column-reverse', sm: 'row' }}
      spacing={1}
      sx={{
        justifyContent: { xs: 'center', sm: 'flex-end' },
      }}
    >
      {!disabledEdit && cancelButton}
      {mainButton}
    </Stack>
  );
};

ProfileEditButtons.propTypes = {
  disabledEdit: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  disableSaveButton: PropTypes.bool.isRequired,
  onEdit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  showInline: PropTypes.bool,
};

ProfileEditButtons.defaultProps = {
  showInline: false,
};

export default ProfileEditButtons;
